import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

import AreaReports from '../../../components/areaReports';

import Slides from '../../../components/slides';

class HualianBeer extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        /**
         * 组件分发数据
         */
        const {
            content: { newsData, posters },
        } = this.props;

        return (
            <div className={styles.hualianBeer}>
                <div className={styles.areaReports}>
                    <AreaReports content={newsData} />
                </div>
                <div className={styles.scene}>
                    <div className={styles.navBar}>
                        <div className={styles.header}>高清大图</div>
                    </div>
                    <Slides content={posters} />
                </div>
            </div>
        );
    }
}

export default errorBoundary(HualianBeer);
